import React, { useState } from 'react';
import './NavigationBar.css';

const NavigationBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-inner">
        {/* Logo */}
        <a href="/" className="logo-link">
          <img
            src="/images/iwpfi_horizontal_logo.jpg"
            alt="IWPFI 2026 Logo"
            className="logo-img"
          />
        </a>

        {/* Hamburger button on small screens */}
        <button
          className="menu-toggle"
          aria-label="Toggle navigation menu"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Nav links */}
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          <li><a href="/">HOME</a></li>
          <li><a href="/About">ABOUT</a></li>
          <li><a href="/CallForAbstracts">ABSTRACTS</a></li>
          <li><a href="/Program">PROGRAM</a></li>

          {/* SPONSORS with hover dropdown */}
          <li className="dropdown">
            <button className="dropdown-trigger" aria-haspopup="true">
              SPONSORS
            </button>
            <ul className="dropdown-menu">
              <li><a href="/Sponsorship">Sponsorship Opportunities</a></li>
              <li><a href="/Sponsors">Sponsors</a></li>
            </ul>
          </li>
          <li className="dropdown">
            <button className="dropdown-trigger" aria-haspopup="true">
              GENERAL INFORMATION
            </button>
            <ul className="dropdown-menu">
              <li><a href="/AboutIWPFI">About IWPFI</a></li>
              <li><a href="/BoardMembers">IWPFI Board Members</a></li>
            </ul>
          </li>
          {/* <li><a href="/GeneralInfo">GENERAL INFORMATION</a></li> */}
          <li><a href="/Registration">REGISTRATION</a></li>
          <li><a href="/Accommodation">ACCOMMODATION</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default NavigationBar;
